import type { ButtonProps } from "@ecco/ui/button";
import { defaultUnderlineStyle } from "@ecco/ui/css/common";
import { focusOutline } from "@ecco/ui/css/focus";

const guideButtonBaseStyles = {
    ...defaultUnderlineStyle,
    cursor: "pointer",
    width: "100%",
    justifyContent: "left",
    _hover: {
        color: "gray.500",
        textDecorationColor: "gray.500",
        backgroundColor: "gray.100",
    },
};

const guideLinkSharedButtonProps = {
    gap: 1.2,
    h: "auto",
    py: "0.4rem",
    px: "0.8rem",
    minH: "auto",
    lineHeight: "1.2",
    fontWeight: "bold",
    display: "inline-flex",
    alignItems: "center",
    variant: "unstyled" as const,
    fontSize: "desktopBodyTextNormal",
};

export const guideDropdownItemAppearance: ButtonProps = {
    ...guideLinkSharedButtonProps,
    ...guideButtonBaseStyles,
};

export const guideTriggerAppearance: ButtonProps = {
    ...guideLinkSharedButtonProps,
    ...guideButtonBaseStyles,
    _focus: { outline: "none", boxShadow: "none" },
    _focusVisible: { ...focusOutline, boxShadow: "none" },
};
